var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormWeightIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_544_7311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0837 1.66663H2.91699C2.58547 1.66663 2.26753 1.79832 2.03311 2.03274C1.79869 2.26716 1.66699 2.58511 1.66699 2.91663V17.0833C1.66699 17.4148 1.79869 17.7328 2.03311 17.9672C2.26753 18.2016 2.58547 18.3333 2.91699 18.3333H17.0837C17.4152 18.3333 17.7331 18.2016 17.9675 17.9672C18.202 17.7328 18.3337 17.4148 18.3337 17.0833V2.91663C18.3337 2.58511 18.202 2.26716 17.9675 2.03274C17.7331 1.79832 17.4152 1.66663 17.0837 1.66663Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.93909C6.38528 6.27242 8.05194 5.43909 10 5.43909C11.9478 5.43909 13.6144 6.27242 15 7.93909",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.9166C10.3315 12.9166 10.6495 12.7849 10.8839 12.5505C11.1183 12.3161 11.25 11.9981 11.25 11.6666C11.25 11.3351 11.1183 11.0172 10.8839 10.7827C10.6495 10.5483 10.3315 10.4166 10 10.4166C9.66848 10.4166 9.35054 10.5483 9.11612 10.7827C8.8817 11.0172 8.75 11.3351 8.75 11.6666C8.75 11.9981 8.8817 12.3161 9.11612 12.5505C9.35054 12.7849 9.66848 12.9166 10 12.9166Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 8.75L10.0037 11.6667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_544_7311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "#727272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormWeightIcon2);
export default __webpack_public_path__ + "static/media/formWeightIcon2.14b392405ddf6ac38e91a6561abcee1c.svg";
export { ForwardRef as ReactComponent };